import {
  vsServiceName as machineConfigurationCellClassServiceName,
  MachineConfigurationCellClassService,
} from "../../../shared/machineConfigurationCellClassService";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import { machineEpromConfigurationObjectName } from "../../../shared/names";

const gridId = Symbol("main.machines.gameProgram.grid");
export class GameProgramViewController {
  static $inject = [
    "environment",
    RecordGridViewServiceName,
    machineConfigurationCellClassServiceName,
  ];

  readonly gridConfiguration: GridConfiguration;
  readonly defaultQuery: any;
  currentOrFutureConfigurationsOnly: boolean = true;

  constructor(
    private readonly environment: { Date: Date },
    recordGridViewService: RecordGridViewService,
    machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {
    this.gridConfiguration = recordGridViewService.getGridConfiguration(
      machineEpromConfigurationObjectName
    )!;
    this.defaultQuery = {
      CurrentConfigurationOrDateGreaterThanOrEqualTo: environment.Date,
    };
    machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      true
    );
  }

  currentOrFutureConfigurationsOnlyChanged(
    currentConfigurationOrDateGreaterThanOrEqualTo: boolean
  ) {
    this.defaultQuery.CurrentConfigurationOrDateGreaterThanOrEqualTo =
      currentConfigurationOrDateGreaterThanOrEqualTo
        ? this.environment.Date
        : undefined;
  }
}
